module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("\n    " + _vm._s(_vm.isEdit ? "编辑分享模板" : "新建分享模板") + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "template-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板类型"
    }
  }, [_c('span', {
    staticClass: "readonly-text"
  }, [_vm._v(_vm._s(_vm.templateTypeText))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "340px"
    },
    attrs: {
      "placeholder": "请输入模板名称，不超过20个字",
      "maxlength": 20
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板图片",
      "prop": "imageUrl"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 300,
      "show-file-list": false
    },
    model: {
      value: (_vm.form.imageUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "imageUrl", $$v)
      },
      expression: "form.imageUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("尺寸建议300 x 280，大小不超过300")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示排序",
      "prop": "sort"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 99,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("\n          输入数字0–99，数字越小越靠前，数字一致时优先展示最近创建的\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "免费类型",
      "prop": "useType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.useType),
      callback: function($$v) {
        _vm.$set(_vm.form, "useType", $$v)
      },
      expression: "form.useType"
    }
  }, _vm._l((_vm.useTypeOptions), function(item) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), (_vm.form.useType === 2) ? _c('div', {
    staticClass: "form-hint"
  }, [_vm._v("\n          模版将出现【限时免费】角标\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7afa35bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/ShareTemplate/ShareTemplateDetail.vue
// module id = 1084
// module chunks = 0